import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import './styles/header.css';
import './styles/homescreen.css';
import './styles/footer.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

